var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "loader",
    { attrs: { "is-loading": _vm.isLoading, "reset-btn": false } },
    [
      _c("custom-drawer", {
        attrs: {
          icon: _vm.generateMessage("logbook.icon"),
          "is-search": "",
          title: _vm.currentProperty.code,
          subtitle: _vm.currentProperty.name,
          "is-pagination": "",
          "is-date-filter": "",
          namespace: "logbook"
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c(
                  "div",
                  _vm._l(_vm.origins, function(origin, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "mt-2" },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "font-weight-bold text-no-wrap",
                                staticStyle: { width: "min-content" }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(origin.description) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-checkbox", {
                              staticClass: "ma-0 pa-0",
                              attrs: {
                                "input-value": _vm.isGroupChecked(origin.id),
                                dense: "",
                                "hide-details": ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.handleGroupCheckedClick(origin.id)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "v-chip",
                              { staticClass: "mx-0", attrs: { small: "" } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.itemsHasAttributeValueNumber(
                                        "origin_id",
                                        origin.id
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.subTypes(origin.id), function(pay, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "d-inline-flex align-center"
                            },
                            [
                              _c("v-checkbox", {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  "hide-details": "",
                                  dense: "",
                                  label: pay.name,
                                  value: pay.id
                                },
                                model: {
                                  value: _vm.selected,
                                  callback: function($$v) {
                                    _vm.selected = $$v
                                  },
                                  expression: "selected"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "v-chip",
                                {
                                  staticClass: "mx-2",
                                  attrs: { "x-small": "" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.itemsHasAttributeValueNumber(
                                          "payload_type_id",
                                          pay.id
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  }),
                  0
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }